import React, { useState } from 'react';
import 'swiper/css';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectCoverflow, Autoplay } from 'swiper/modules';

import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import VideoPlay from './VideoPlay';
const Video = () => {
     const [selectedVideo, setSelectedVideo] = useState(null);
     const destinations = [
        {
          url: 'https://www.youtube.com/watch?v=iE4Wo6g0X54',
          thumbnail: 'https://img.youtube.com/vi/iE4Wo6g0X54/hqdefault.jpg',
        },
        {
          url: 'https://www.youtube.com/watch?v=Ku3uw2loFMg',
          thumbnail: 'https://img.youtube.com/vi/Ku3uw2loFMg/hqdefault.jpg',
        },
        {
          url: 'https://www.youtube.com/watch?v=1VK60Z0Lfxw',
          thumbnail: 'https://img.youtube.com/vi/1VK60Z0Lfxw/hqdefault.jpg',
        },
        {
          url: 'https://www.youtube.com/watch?v=vZgXZaHYm-U',
          thumbnail: 'https://img.youtube.com/vi/vZgXZaHYm-U/hqdefault.jpg',
        },
        {
          url: 'https://www.youtube.com/watch?v=1FO7vFawuLI',
          thumbnail: 'https://img.youtube.com/vi/1FO7vFawuLI/hqdefault.jpg',
        },
      ];
  return (
    <div>
    <section className="position-relative overflow-hidden space-bottom" id="destination-sec">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title">Videos</span>
        </div>
        <div className="row gy-4 gx-4">
          {destinations.map((video, index) => (
            <div key={index} className="col-xl-3 col-lg-4 col-md-6">
              <div className="destination-item th-ani">
                <div className="destination-item_img global-img">
                  <img src={video.thumbnail} alt={`video-${index}`} />
                </div>
                <div className="destination-content">
                  <button
                    className="th-btn style4 th-icon"
                    onClick={() => setSelectedVideo(video.url)}
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  <footer class="footer-wrapper footer-layout1">
        <div class="widget-area">
            <div class="container">
                <div class="newsletter-area">
                    <div class="newsletter-top">
                        <div class="row gy-4 align-items-center">
                            <div class="col-lg-5">
                                <h2 class="newsletter-title text-capitalize mb-0">Subscribe to Drone TV</h2>
                            </div>
                            <div class="col-lg-7">
                                <form class="newsletter-form">
                                    <input class="form-control " type="email" placeholder="Enter Email" required=""/>
                                    <button type="submit" class="th-btn style3">Subscribe Now <img src="assets/img/icon/plane.svg" style={{width:"50%", height:"50%"}} alt="/"/></button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-between">
                    <div class="col-md-6 col-xl-3">
                        <div class="widget footer-widget">
                            <div class="th-widget-about">
                                <div class="about-logo">
                                    <a href="home-travel.html"><img src="assets/img/hero/logo.jpg" alt="Tourm"/></a>
                                </div>
                              
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">Quick Links</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">

                                <li>
                        <Link to="/" className="active">Home</Link>
                      </li>
                      <li>
                        <Link to="/video">Videos</Link>
                      </li>
                      <li>
                        <Link to="/event">Events</Link>
                      </li>
                      <li>
                        <Link to="/community">Community</Link>
                      </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget footer-widget">
                            <h3 class="widget_title">Address</h3>
                            <div class="th-widget-contact">
                                <div class="info-box_text">
                                    <div class="icon">
                                        <img src="assets/img/icon/phone.svg" alt="img"/>
                                    </div>
                                    <div class="details">
                                        <p style={{marginTop:"12px"}}><a href="tel:+917520123555" class="info-box_link">+91 7520123555</a></p>
                                    </div>
                                </div>
                                <div class="info-box_text">
                                    <div class="icon">
                                        <img src="assets/img/icon/envelope.svg" alt="img"/>
                                    </div>
                                    <div class="details">
                                        <p style={{marginTop:"12px"}}><a href="mailto:info@dronetv.in" class="info-box_link">info@dronetv.in</a></p>
                                    </div>
                                </div>
                                <div class="info-box_text">
                                    <div class="icon"><img src="assets/img/icon/location-dot.svg" alt="img"/></div>
                                    <div class="details">
                                        <p style={{marginTop:"12px"}}> HICC, Hyderabad, India</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget footer-widget">
                            <h3 class="widget_title">Social media</h3>
                            <div class="th-social">
                                    <a href="https://www.facebook.com/"><i class="fab fa-facebook-f"></i></a>
                                    <a href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a>
                                    <a href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a>
                                    <a href="https://www.whatsapp.com/"><i class="fab fa-whatsapp"></i></a>
                                    <a href="https://instagram.com/"><i class="fab fa-instagram"></i></a>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright-wrap" data-bg-src="assets/img/bg/copyright_bg_1.jpg">
            <div class="container">
                <div class="row justify-content-between align-items-center" style={{textAlign:"center"}}>
                    <div class="col-md-6">
                        <p class="copyright-text">Copyright 2025 <a href="home-travel.html">AJS Innovations</a>. All Rights Reserved.</p>
                    </div>
                   
                </div>

            </div>
        </div>

    </footer>
    {selectedVideo && (
      <VideoPlay
        videoUrl={selectedVideo}
        onClose={() => setSelectedVideo(null)}
      />
    )}
  </div>
  )
}

export default Video